import { useQuery } from '@tanstack/react-query';
import { queryKey } from '../../../constant/queryKey';
import { marketService, type MarketParent } from 'shared/src/api';

export const useMarketParent = (marketId: number) => {
  return useQuery<MarketParent>({
    queryKey: queryKey.marketParent(marketId),
    queryFn: () => marketService.getMarketParent(marketId),
  });
};
